import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  *{
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }

  html{
      @media(max-width:1100px) {
          font-size: 62.5%; 
      }
  }

  body{
      background: #ffffff;
      font-family: 'Open Sans', sans-serif;
      overflow-x: hidden;
      min-height: 100vh;
  }

  button{
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 1.1rem;
      cursor: pointer;
      padding: .5rem 1.5rem;
      margin: 1.4rem 0rem;
      border: none;
      background-color: #5E9C98;
      width: 9rem;
      height: 3.5rem;
      color:white;
      transition: all 0.5s ease;
      list-style: none;
      &:hover{
          background-color: #375C5A;
          color:white;
      }
      @media(max-width:768px) {
        &:hover{
          background-color: #375C5A;
          color:white;
      }
                }
  }
      
h1{
    font-size: 3.5rem;
    font-weight: lighter;
    line-height: 3.4rem;
    font-family: 'Cormorant', serif;
    @media(max-width:768px) {
        text-align: center;    
}
}

h2{
          font-weight: lighter;
          font-family: 'Cormorant', serif;
          font-size: 2rem;
          line-height: 1.5rem;
      }

h3{
          color:black;
          font-size: 1rem;
          font-weight: normal;
      }

h4{
          font-weight: bold;
          line-height:2rem;
          font-size: 1rem;          
      }

a{
    font-size: 1.1rem;
    text-decoration: none;
    color: inherit;
    font-weight: 400;
    }
p{
          padding: 2rem 0rem;
          font-size:1.1rem;
          /* line-height: 1%; */
      }
`;

export default GlobalStyle;
